import { getLocale } from '@umijs/max';

import dayjs from 'dayjs';

import { UmiLocale } from '@/types';

export const getDatePickerFormat = (): string | undefined => {
  const locale = getLocale() as UmiLocale;

  const languageCode = locale.split('-')[0];

  const dateFormat = dayjs.Ls[languageCode].formats.L;

  return dateFormat;
};

export const getDateTimePickerFormat = (): string => {
  const locale = getLocale() as UmiLocale;

  const languageCode = locale.split('-')[0];

  const dateFormat = dayjs.Ls[languageCode].formats.L;
  const timeFormat = dayjs.Ls[languageCode].formats.LT;

  return `${dateFormat}, ${timeFormat}`;
};

export const getDateTimeIsoStringFromPickerFormat = (date: string): string => {
  const locale = getLocale() as UmiLocale;

  if (dayjs(date).isValid() && locale !== 'en-US') {
    return date;
  }

  const languageCode = locale.split('-')[0];

  const dateFormat = dayjs.Ls[languageCode].formats.L;
  const timeFormat = dayjs.Ls[languageCode].formats.LT;

  return dayjs(date, `${dateFormat}, ${timeFormat}`).toISOString();
};
